import { BundleItemOption, BundleProduct } from '@storefront/data-commerce';
import { HeldError } from '@storefront/shared-components/error-information/held-error';
import { ProductConfiguration } from '@storefront/types/Product';
import { getRegularPrice } from '@storefront/utils/priceHandler';

import { FlagsContextProps } from '@storefront/context/LDFlagsContext';
import {
  getComplexOptions,
  getCoreOffer,
} from '@storefront/utils/prodRequests';
import {
  BundleItemWithLowestPrice,
  BundleProductWithLowestPrice,
} from '../product-configuration/product-configuration.utils';

import { FeatureFlagData } from '@storefront/types/featureFlagData';

export const getSkuList = (skuList: string) =>
  skuList?.split('_').map((sku) => sku.split('-')[0]);

export const saveProductConfiguration = (
  configuration: ProductConfiguration
) => {
  try {
    sessionStorage.setItem(
      'product-configuration',
      JSON.stringify(configuration)
    );
  } catch (error) {
    console.error('Error saving configuration', error);
  }
};

export const loadProductConfiguration = () => {
  const savedConfiguration = sessionStorage.getItem('product-configuration');
  if (savedConfiguration) {
    let configuration: ProductConfiguration;
    try {
      configuration = JSON.parse(savedConfiguration) as ProductConfiguration;
    } catch (error) {
      console.error('Error parsing saved configuration', error);
      configuration = undefined;
    }
    return configuration;
  }
  return undefined;
};
export const findProductOption = (
  sku: string,
  multipleProduct: BundleProductWithLowestPrice[]
): BundleItemOption => {
  const product = multipleProduct.find((product) => product.sku === sku);
  return getCoreOffer(getComplexOptions(product)?.[0], product);
};
export const findBundleOption = (
  sku: string,
  multipleProduct: BundleProductWithLowestPrice[]
): BundleProduct => multipleProduct.find((product) => product.sku === sku);
// Should be unmocked once BE data is ready
export const classifyPrinter = (product: BundleProduct) => {
  if (!product?.hp_model_purpose) {
    console.error('Missing required field hp_model_purpose');
    throw new HeldError('errors.SOMETHING_WENT_WRONG');
  }
  return product.hp_model_purpose;
};

export const isPrinterPopular = (
  multipleProduct: BundleProductWithLowestPrice[],
  sku: string
) => {
  const bundleProduct = multipleProduct.filter(
    (product) => product.sku === sku
  );
  return bundleProduct[0]?.hp_is_popular !== 0;
};

// Should be unmocked once BE data is ready (now its mocked just for QA purpose)
export const isBackOrderShipping = (enableBackOrder: boolean, sku: string) =>
  enableBackOrder && sku === 'EnvyOnbooks.00002';

export const handleMappedSkus = (skuList: string[]) =>
  skuList.map((sku) =>
    sku === 'OfficeJetOnbooks.00001' ? 'MarconiV1.onbooks.00001' : sku
  );

export const isZeroDollarPaperPlan = (
  bundleOption: BundleItemWithLowestPrice
) => bundleOption?.options.some((option) => getRegularPrice(option) === 0);

export const applyFeatureFlagI18nData = <
  T extends {
    featureFlags?: FeatureFlagData<T>[];
  }
>(
  i18nItem: T,
  flags: FlagsContextProps | undefined
): T => {
  if (!i18nItem.featureFlags?.length || !flags) return i18nItem;

  const ffData = i18nItem.featureFlags.find(
    (featureFlag) => flags[featureFlag.name] === true
  );

  return ffData ? { ...i18nItem, ...ffData.data } : i18nItem;
};
